import { render, staticRenderFns } from "./Variaveis.vue?vue&type=template&id=014f17a5&"
import script from "./Variaveis.vue?vue&type=script&lang=js&"
export * from "./Variaveis.vue?vue&type=script&lang=js&"
import style0 from "../../templates/assets/default.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports